import {
  getData,
  // postData, putData
} from "../../../common/utils/network.utils";

export const getCommunityData = async () => {
  return (await getData('community/community-data')).data;
}